module.exports = __webpack_public_path__ + "img/9788982816505.fb7eeff4.jpg";